import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import { GlobalFormats } from '../../classess/main/globalFormats';

import { Company } from '../../classess/company/company';
import { Country } from '../../classess/country/country';

import moment from 'moment';

import CompanyAddEditDetails from './CompanyAddEditDetails';
import {
    badgetStatusGeneric, getProcessButtons, dataTableLanguaje, setDateTimeFormatGlobalString, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, handleResponseMessageAsync, settings, styles, LoadingSection,
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { CompanyService } from '../../services/companies/CompanyService';
import { CountryService } from '../../services/countries/CountryService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const currentMethod = 'Companies';

const { html, colors, icons, images, labels, messages, } = settings;

export default function Companies({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const dtCompaniesId = 'dtCountries';
    const [process, setProcess] = useState({
        showLoading: false,
        add: false,
        edit: false,
        delete: false,
    });
    const isMount = useRef(true);
    const [showData, setShowData] = useState(true);
    const [company, setCompany] = useState(Company?.getClass({}, false));
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        countries: [Country?.class({}, false)],
        languageObj: languageObj,
        dtCompaniesId: dtCompaniesId,
        dtCompaniesRowId: 0,
    });
    const localFormats = {
        dateTime: {
            date: languageObj?.format?.date?.f1,
            time: languageObj?.format?.time?.type,
            timeAddHours: 4,
        },
    };
    const controls = {
        buttons: {
            addEditDetails: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddEditDetails',
            },
        },
        icons: {
            addEditDetails: {
                id: 'iconAddEditDetails',
                defaultClass: icons?.fasFa?.plusCircle,
            },
        },
        spiners: {
            addEditDetails: {
                id: 'spAddEditDetails',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region companies
    const getAddCompany = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getAddCompany';
        try {
            //#region variables
            let countries = [];
            //#endregion variables

            setProcess(prev => ({
                ...prev,
                showLoading: true,
                add: true,
            }));

            e?.preventDefault?.();

            //#region get countries
            response = await getCountries({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            countries = response?.result?.countries;
            //#endregion get countries

            setCompany(prev => ({
                ...Company?.getClass({}, false),
                registerDate: moment(new Date())?.format(`${modalObj?.languageObj?.format?.date?.f13} ${modalObj?.languageObj?.format?.time?.f2}`),
            }));

            setModalObj(prev => ({
                ...prev,
                type: 0,
                showModal: true,
                countries: countries,
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
                add: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getEditCompany = async ({
        e = {},
        id = '',
        description = '',
        rowId = '',
        processType = 1,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getEditCompany';
        try {
            //#region variables
            let countries = [];
            let companyData = Company?.getClass({}, false);
            //#endregion variables

            setProcess(prev => ({
                ...prev,
                showLoading: true,
                edit: true,
            }));

            e?.preventDefault?.();

            //#region get countries
            response = await getCountries({
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            countries = response?.result?.countries;
            //#endregion get countries

            //#region company (get byid)
            response = await CompanyService.getById({
                auth,
                id,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning) return;

            companyData = !isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
                !isUndNullEmp({ data: response?.result?.company, subMethod: currentMethod })?.result &&
                !isUndNull({ data: response?.result?.company?.id, subMethod: currentMethod })?.result &&
                response?.result?.company?.id > 0 ?
                Company?.getClass(response?.result.company, false) :
                {};
            //#endregion company (get byid)

            //#region check data
            if (isUndNullEmp({ data: companyData, subMethod: currentMethod })?.result) {
                response = getResponse({ type: -1 });
                response.msgText = `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/>${labels?.name?.[languageObj?.id]}: <b>${description}</b><br/>`;
                return;
            }
            //#endregion check data

            setCompany(Company?.getClass(companyData, false));

            setModalObj(prev => ({
                ...prev,
                type: processType,
                showModal: true,
                countries: countries,
                dtCompaniesRowId: rowId,
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
                edit: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const deleteCompany = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deleteCompany';
        try {
            e?.preventDefault?.();

            //#region show message
            const msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.company?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`
            };
            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: colors.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: colors.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data (company)
                        preConfirmResponse = await CompanyService.deleteAsync({
                            auth,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (company)

                        //#region delete datatable (company)
                        $(`#${dtCompaniesId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);

                        preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                        //#endregion delete datatable (company)
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    } finally {
                        // Helper v2.2: Silent inside Swal
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire(swalProperties);

            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
                delete: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion companies

    //#region countries
    const getCountries = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getCountries';
        try {
            //#region variables
            let countries = [];
            let finalData = {
                countries: countries,
            }
            //#endregion variables

            //#region country (getall)
            response = await CountryService.getAll({
                auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning) return response;

            const countriesData = !isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
                !isUndNullEmp({ data: response?.result?.countries, subMethod: currentMethod })?.result &&
                response?.result?.countries?.length > 0 ?
                response?.result?.countries :
                [];

            if (countriesData.length > 0) {
                countriesData.sort((a, b) => (a.name > b.name) ? 1 : -1);
                countriesData.forEach((country) => {
                    countries.push(Country?.class(country, false));
                })
            }

            finalData.countries = countries;
            //#endregion country (getall)

            //#region set final data
            response.result = finalData;
            //#endregion set final data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
    //#endregion countries

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            //#region variables
            let companies = [];
            //#endregion variables

            setProcess(prev => ({
                ...prev,
                showLoading: true,
            }));

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                //#region datatable (set)
                response = setDataTables({
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (companies)
                response = await CompanyService.getAll({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                });

                if (!response?.isSuccess || response?.isWarning) return;

                companies = response?.result?.companies || [];
                //#endregion get data (companies)

                //#region set datatable
                if (companies.length > 0) {
                    response = setDataInDataTable({
                        data: companies,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                response = getResponse({ type: 1 });
                response.isSuccess = false;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
            }));

            if (!response?.isSuccess) {
                setShowData(false);
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataTables';
        try {
            $(`#${dtCompaniesId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.code[languageObj?.id], width: '10%', },
                    { title: labels?.description?.[languageObj?.id], width: '62%', },
                    { title: labels?.enabled?.[languageObj?.id], width: '10%', className: 'text-center', },
                    { title: labels?.registered[languageObj?.id], width: '13%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtCompaniesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            //#region process
            $(`#${dtCompaniesId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtCompaniesId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    // const attribute = e?.target?.attributes?.method;
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';

                    switch (methodName) {
                        case 'edit':
                            getEditCompany({
                                e: e,
                                id: id_,
                                description: description,
                                rowId: rowId,
                                processType: 1,
                                subMethod: currentMethod,
                            });
                            break;
                        case 'details':
                            getEditCompany({
                                e: e,
                                id: id_,
                                description: description,
                                rowId: rowId,
                                processType: 2,
                                subMethod: currentMethod,
                            });
                            break;
                        case 'delete':
                            deleteCompany({
                                e: e,
                                id: id_,
                                description: description,
                                rowId: rowId,
                                subMethod: currentMethod,
                            });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            const countriesDt = [];

            //#region process
            data.forEach((company) => {
                const modelCompany = Company?.getClass(company, false);

                countriesDt.push([
                    modelCompany.secundaryId,
                    modelCompany.name,
                    badgetStatusGeneric({
                        type: modelCompany.isAvailable ? 0 : 5,
                        value: modelCompany.isAvailable ? labels?.yes?.[languageObj?.id] : labels?.no?.[languageObj?.id],
                    }),
                    setDateTimeFormatGlobalString({
                        date: modelCompany.registerDate,
                        dateFormat: localFormats.dateTime.date,
                        timeFormat: 0,
                        withSeconds: false,
                        subMethod: currentMethod,
                    })?.result,
                    getProcessButtons({
                        id: modelCompany.id,
                        description: modelCompany.name,
                        showDetails: true,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: true,
                        showDelete: true,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        processButtons: [],
                    })?.result,
                ]);
            });

            $(`#${dtCompaniesId}`)?.DataTable()?.rows?.add(countriesDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'index - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={settings?.app?.views?.settings?.settings} process={settings?.app?.views?.companies.companies} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.companies?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.companies?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.companies?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.company}></img>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.companies?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.building} mr-1`}></i> {labels?.index?.[languageObj?.id] || 'Maintenance'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addEditDetails?.id}
                                                            type='button'
                                                            className={process?.add ? `${controls?.buttons?.addEditDetails?.defaultClass} ${settings?.react?.html?.button?.classes?.disabled}` : controls?.buttons?.addEditDetails?.defaultClass}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            disabled={process?.add}
                                                            onClick={(e) => getAddCompany({ e: e, subMethod: controls?.buttons?.addEditDetails?.id })}
                                                            style={{ borderRadius: '5px' }}>
                                                            {process?.add ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.addEditDetails?.id} className={controls?.icons?.addEditDetails?.defaultClass} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtCompaniesId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>

            </div>

            {modalObj?.showModal && (
                <CompanyAddEditDetails modalObj={modalObj}
                    setModalObj={setModalObj}
                    company={company}
                    setCompany={setCompany} />
            )}
        </div>
    )
}